import { dispatch } from 'redux';
import * as spinnerActions from './spinnerActions';
import requiredActionsFromConfig from '../common/requiredActionsConfig';

/**
 * Switch pending status until component doesn't fetch required data
 *
 * @param {Object} component - React component
 * @param {Array} actions - promised actions
 * @param {Boolean} runActionsFromConfig - if we need to run actions from config (src/common/requiredActionsConfig)
 * @param {Boolean} showSpinner - if we need to show spinner until data is fetching
 * @param {Boolean} renderUntilLoading - data to render until component is loading
 *
 * @return void
 * */
export function performRequiredActions(component, actions = [], runActionsFromConfig = true, showSpinner = true, renderUntilLoading = null) {
    return function (dispatch) {
        if(showSpinner) {
            dispatch(spinnerActions.showSpinner());
        }

        const originalRenderFunction = component.render;
        component.render = () => renderUntilLoading;

        if(component.props.match) {
            let pageRoute = component.props.match.path;
            if(runActionsFromConfig && requiredActionsFromConfig[pageRoute] instanceof Array) {
                requiredActionsFromConfig[pageRoute].forEach(action => actions.push(dispatch(action())));
            }
        }

        Promise.all(actions)
            .then(() => {
                component.render = originalRenderFunction;
                component.forceUpdate();
                dispatch(spinnerActions.hideSpinner());
            });
    };
}


// WEBPACK FOOTER //
// ./web/src/actions/pendingPageActions.js